<template>
  <a-layout class='index animated fadeIn'>
    <a-card>
      <div class="mb15">
        <span class='mr15'>
          <a-button type="primary" v-has:brand_create="()=> {$router.push('/brand/brand_create?type=add')}">
            <PlusOutlined />
            添加品牌商
          </a-button>
        </span>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="关键词" name='keywords'>
          <a-input v-model:value="search.keywords" style="width:250px" placeholder="请输入品牌商编号/账号"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' style="marginTop:10px">搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:virtual="{ record }">
            <a-switch v-model:checked="record.is_open_virtual" :checkedValue="1" :unCheckedValue="0"  checked-children="启用" un-checked-children="禁用" v-authAction:setPadVirtual="()=>switchChange(record)"></a-switch>
        </template>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                    <a v-has:brand_detail="()=> {$router.push('/brand/brand_list/detail?type=list&id='+record.id)}" href="javascript:;">详情</a>
                </a-menu-item>
                <a-menu-item>
                    <a v-has:brand_edit="()=> {$router.push('/brand/brand_edit?type=edit&&id='+record.id)}" href="javascript:;">修改</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
</template>
<script>
import { DownOutlined,QuestionCircleFilled,PlusOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs, h } from "vue";
import { message, Modal } from "ant-design-vue";
import { $iscode } from "@/utils/app";
import {
  getBrandtList,

} from "@/api/brand";
import {set_pad_virtual} from '@/api/codeManage'
// 初始化默认筛选项数值
let defSearch = {
  keywords: "",
  page: 1,
  limit: 10,
};
export default {
  components: { DownOutlined,PlusOutlined },
  setup(props) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const formRef = ref(null);
    const state = reactive({
      brandItem: {},
      visibleUp:false,//升级
      listLoading: false,
      visible: false,
      visibleC: false,
      total: 1,
      valueRadio: null,
      time: [],
      price: "",
      commission: "",
      confirmLoading: false,
      visibleBuy:false,
      buyData:[],
      visiblePackages:false,
      packages:[],
      show:false,
      form:{
        
      },
      moduleList:[], //模块
      allCheckbox:[],
      moduleInfo:{
        company:"",
        account:'',
        renew_year:''
      },
      app_is_super:0,// 1全包 0自选
      service_price:0 //服务价
    });
    let columns = [
      {
        title: "品牌商编号",
        dataIndex: "brand_no",
        key: "brand_no",
      },
      {
        title: "公司名称",
        dataIndex: "company",
        key: "company",
      },
      {
        title: "品牌商账号",
        dataIndex: "account",
        key: "account",
      },
      {
        title: "状态",
        dataIndex: "status_text",
        key: "status_text",
      },
      {
        title: "使用垛标操作",
        key: "action",
        slots: { customRender: "virtual" },
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];


    const $router = inject("$router");
    const $Modal = inject("$Modal");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, size) => {
      search.value.page = 1;
      search.value.limit = size;
      initData(search.value);
    };

    const initData = async (values) => {
      state.listLoading = true;
      data.value = [];
      try {
        let res = await getBrandtList(values).then(res=>res.data);
        state.listLoading = false;
        if ($iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.message);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    onMounted(() => {
      initData(search.value);
      
    });
    const switchChange=async (e)=>{
        let res = await set_pad_virtual(e.brand_no,{is_open_virtual:e.is_open_virtual?1:0}).then(res => res.data);
       $iscode(res,true)
      initData(search.value);

    }
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      switchChange
    };
  },
};
</script>
<style scope>
.tis {
  color: #f5222d;
}
.active_tip {
  position: absolute;
  display: none;
}
.active_box:hover .active_tip{
  position: absolute;
  top:50%;
  left:130px;
  display: block;
  border-radius: 4px;
  /* transform: translateY(-50%); */
}
</style>